// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog[data-v-10197667]  .modal-body{width:420px;padding:40px}.title[data-v-10197667]{width:100%;font-size:1.28571rem;line-height:1.57143rem;color:#000;margin:0 auto 30px;text-align:center}.btns-wrapper[data-v-10197667]{width:100%;display:flex;flex-direction:row;align-items:center;justify-content:center}.btns-wrapper .btn[data-v-10197667]{width:144px}", ""]);
// Exports
module.exports = exports;
